import { render } from "./FadedEdgesScrollableFragment.vue?vue&type=template&id=7ce833c8&ts=true"
import script from "./FadedEdgesScrollableFragment.vue?vue&type=script&lang=ts"
export * from "./FadedEdgesScrollableFragment.vue?vue&type=script&lang=ts"

import "./FadedEdgesScrollableFragment.vue?vue&type=style&index=0&id=7ce833c8&lang=css"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__